export function createBus() {
    const listeners = new Set();
    return {
        emit(event) {
            for (const l of listeners) {
                try {
                    l(event);
                }
                catch (err) {
                    // Bus listeners must never throw upstream — but log to console for dev visibility.
                    // Production : on logue Sentry.captureException via hook upstream.
                    // eslint-disable-next-line no-console
                    console.error('[game-shell bus] listener threw', err);
                }
            }
        },
        on(listener) {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        onType(type, listener) {
            const wrapped = (event) => {
                if (event.type === type) {
                    listener(event);
                }
            };
            listeners.add(wrapped);
            return () => listeners.delete(wrapped);
        },
    };
}
//# sourceMappingURL=bus.js.map